/* Health By Natures - Signature theme JS. Vanilla, no dependencies. */
(function () {
  'use strict';
  const HB = (window.HB = window.HB || {});
  HB.settings = HB.settings || {};
  HB.strings = HB.strings || {};
  const S = HB.settings;
  const T = HB.strings;
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const money = (c) => (typeof HB.money === 'function' ? HB.money(c) : '₪' + (c / 100).toFixed(2));
  const reducedPref = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // the accessibility menu's "stop animations" is a reduced-motion request just like the system setting
  const noMotion = () => reducedPref || document.documentElement.classList.contains('a11y-motion');
  const reduced = reducedPref;

  /* ---------------- Toast ---------------- */
  HB.toast = function (msg, ok) {
    const region = $('#ToastRegion');
    if (!region) return;
    const el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = (ok === false ? '' : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 7"/></svg>') + '<span></span>';
    el.querySelector('span').textContent = msg;
    region.appendChild(el);
    setTimeout(() => { el.style.opacity = '0'; el.style.transition = 'opacity .3s'; setTimeout(() => el.remove(), 320); }, 2600);
  };

  /* ---------------- Fetch helpers ---------------- */
  async function request(url, opts) {
    const res = await fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}));
    const data = await res.json().catch(() => ({}));
    if (!res.ok) { const err = new Error(data.description || data.message || T.error || 'Error'); err.data = data; throw err; }
    return data;
  }
  const BASE_SECTIONS = 'cart-drawer,cart-icon-bubble';
  // the cart page section id differs per template (Shopify prefixes JSON template sections), so read it from the DOM
  const mainCartId = () => { const el = $('[data-main-cart]'); return el && el.dataset.sectionId ? el.dataset.sectionId : null; };
  const sectionsList = () => { const id = mainCartId(); return id ? BASE_SECTIONS + ',' + id : BASE_SECTIONS; };

  /* ---------------- Cart ---------------- */
  HB.cart = {
    async add(items, opts) {
      opts = opts || {};
      const body = { items: Array.isArray(items) ? items : [items], sections: sectionsList(), sections_url: window.location.pathname };
      const data = await request((S.cartAddUrl || '/cart/add') + '.js', { method: 'POST', body: JSON.stringify(body) });
      await HB.cart.renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      if (opts.open !== false && S.cartDrawer && HB.drawer) HB.drawer.open('CartDrawer');
      else if (!opts.silent) HB.toast(T.added || 'Added');
      return data;
    },
    async change(lineKeyOrIndex, quantity) {
      const body = { quantity, sections: sectionsList(), sections_url: window.location.pathname };
      if (typeof lineKeyOrIndex === 'number') body.line = lineKeyOrIndex; else body.id = lineKeyOrIndex;
      const data = await request((S.cartChangeUrl || '/cart/change') + '.js', { method: 'POST', body: JSON.stringify(body) });
      await HB.cart.renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      return data;
    },
    async update(updates) {
      const data = await request((S.cartUpdateUrl || '/cart/update') + '.js', { method: 'POST', body: JSON.stringify({ updates, sections: sectionsList() }) });
      await HB.cart.renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      return data;
    },
    async refresh() {
      try {
        const res = await fetch(`${window.location.pathname}?sections=${sectionsList()}`, { headers: { Accept: 'application/json' } });
        const sections = await res.json();
        HB.cart.renderSections(sections);
      } catch (e) { /* offline preview */ }
    },
    renderSections(sections) {
      if (!sections) return;
      // A re-render replaces the lines, which would drop keyboard focus onto the page body. Remember
      // which control of which line had it, and hand it back to the same control afterwards.
      const active = document.activeElement;
      const activeLine = active && active.closest ? active.closest('[data-cart-line]') : null;
      const lineKey = activeLine ? activeLine.querySelector('[data-cart-qty]')?.dataset.cartQty : null;
      const role = !activeLine ? null : active.matches('[data-cart-remove]') ? 'remove' : (active.dataset.action || 'input');
      const parser = new DOMParser();
      if (sections['cart-drawer']) {
        const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer-content]');
        const current = $('[data-cart-drawer-content]');
        if (fresh && current) current.replaceWith(fresh);
      }
      if (sections['cart-icon-bubble']) {
        const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const fresh = doc.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach((el) => { if (fresh) { el.textContent = fresh.textContent; el.dataset.count = fresh.dataset.count; } });
      }
      // main cart page
      const mcId = mainCartId();
      if (mcId && sections[mcId]) {
        const doc = parser.parseFromString(sections[mcId], 'text/html');
        const fresh = doc.querySelector('[data-main-cart]');
        const current = $('[data-main-cart]');
        if (fresh && current) current.replaceWith(fresh);
      }
      if (lineKey) {
        const qty = document.querySelector(`[data-cart-qty="${CSS.escape(lineKey)}"]`);
        const line = qty && qty.closest('[data-cart-line]');
        const target = !line ? null : role === 'remove' ? line.querySelector('[data-cart-remove]') : role === 'input' ? qty : line.querySelector(`[data-action="${role}"]`);
        if (target) target.focus({ preventScroll: true });
        else document.querySelector('[data-cart-drawer-content] [data-cart-line] [data-cart-qty], [data-main-cart] [data-cart-qty]')?.focus({ preventScroll: true });
      }
    }
  };

  /* ---------------- Drawers (cart + menu) ---------------- */
  HB.drawer = {
    open(id) {
      const d = document.getElementById(id);
      if (!d) return;
      d.classList.add('is-open'); d.removeAttribute('hidden'); d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      const focus = d.querySelector('[data-autofocus], button, a, input');
      if (focus) setTimeout(() => focus.focus({ preventScroll: true }), 120);
      d.dispatchEvent(new CustomEvent('drawer:open'));
    },
    close(id) {
      const list = id ? [document.getElementById(id)] : $$('.drawer.is-open');
      list.forEach((d) => { if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
      if (!$('.drawer.is-open')) document.body.classList.remove('drawer-open');
    }
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); HB.drawer.open(opener.dataset.drawerOpen); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      // a real link inside a drawer (e.g. 'view all' in the empty cart) still navigates, the drawer just closes too
      if (!closer.matches('a[href]')) e.preventDefault();
      HB.drawer.close(closer.closest('.drawer') ? closer.closest('.drawer').id : undefined);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') HB.drawer.close(); });

  /* ---------------- fly to cart ---------------- */
  // The bottle lifts off the page, arcs to the cart icon and shrinks into it, then the drawer
  // opens. Only transform and opacity animate, so it stays on the compositor in a webview.
  const FLY_SEL = '.product-card__media img, .gallery__slide img, .product__media img, .duo__fly';
  function flySource(el) {
    const scope = el.closest('.product-card, .product__main, .product, section');
    let list = scope ? Array.from(scope.querySelectorAll(FLY_SEL)) : [];
    if (!list.length) list = $$(FLY_SEL);
    // an image inside a [hidden] or display:none box has no client rects; it must never be the one that flies
    const shown = list.filter((img) => img.getClientRects().length);
    const pool = shown.length ? shown : list;
    const onscreen = pool.find((img) => {
      const r = img.getBoundingClientRect();
      return r.width > 30 && r.bottom > 0 && r.top < window.innerHeight;
    });
    return onscreen || pool[0] || null;
  }
  HB.flyToCart = function (source, origin) {
    const done = Promise.resolve();
    if (noMotion() || !origin || typeof origin.animate !== 'function') return done;
    const target = $('[data-drawer-open="CartDrawer"]');
    if (!target) return done;
    const from = origin.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    if (!from.width || !from.height) return done;

    // the flight starts on the button the shopper actually pressed - on a phone that is the only
    // thing guaranteed to be on screen, and it reads as the product jumping out of the button
    const size = 62;
    const cx = from.left + from.width / 2;
    const cy = from.top + from.height / 2;
    const ghost = document.createElement('div');
    ghost.className = 'fly-ghost';
    ghost.style.left = (cx - size / 2) + 'px';
    ghost.style.top = (cy - size / 2) + 'px';
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    if (source) {
      const img = document.createElement('img');
      img.src = source.currentSrc || source.src;
      img.alt = '';
      ghost.appendChild(img);
    }
    document.body.appendChild(ghost);

    // the header can be scrolled away, so keep the landing point inside the viewport
    const dx = (to.left + to.width / 2) - cx;
    const dy = Math.max(14, Math.min(window.innerHeight - 14, to.top + to.height / 2)) - cy;
    const lift = Math.min(110, Math.max(50, Math.abs(dy) * 0.35));

    const anim = ghost.animate([
      { transform: 'translate3d(0, 0, 0) scale(.3)', opacity: 0.2, offset: 0 },
      { transform: 'translate3d(' + dx * 0.12 + 'px, ' + (dy * 0.12 - lift * 0.35) + 'px, 0) scale(1.06)', opacity: 1, offset: 0.2 },
      { transform: 'translate3d(' + dx * 0.55 + 'px, ' + (dy * 0.55 - lift) + 'px, 0) scale(.92)', opacity: 1, offset: 0.6 },
      { transform: 'translate3d(' + dx + 'px, ' + dy + 'px, 0) scale(.26)', opacity: 0.15, offset: 1 }
    ], { duration: 720, easing: 'cubic-bezier(.36,.02,.22,1)', fill: 'forwards' });

    const finish = anim.finished || new Promise((r) => { anim.onfinish = r; });
    return finish.catch(() => {}).then(() => {
      ghost.remove();
      const bubble = $('[data-cart-count]');
      if (bubble && bubble.animate) {
        bubble.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.5)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.3,1.5,.4,1)' });
      }
    });
  };

  /* ---------------- Cart drawer interactions ---------------- */
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      rm.closest('.cart-line, [data-cart-line]')?.classList.add('is-loading');
      try { await HB.cart.change(rm.dataset.cartRemove, 0); } catch (err) { HB.toast(err.message, false); }
      return;
    }
    const up = e.target.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      up.disabled = true;
      try { await HB.cart.add({ id: Number(up.dataset.upsellAdd), quantity: 1 }, { open: false, silent: true }); HB.toast(T.added); } catch (err) { HB.toast(err.message, false); up.disabled = false; }
    }
  });
  document.addEventListener('change', async (e) => {
    const q = e.target.closest('[data-cart-qty]');
    if (!q) return;
    const units = Math.max(0, parseInt(q.value, 10) || 0);
    q.closest('.cart-line, [data-cart-line]')?.classList.add('is-loading');
    try { await HB.cart.change(q.dataset.cartQty, units); } catch (err) { HB.toast(err.message, false); }
  });
  // Enter in a cart quantity box must not submit the cart form (and head to checkout) mid-update
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !e.target.closest('[data-cart-qty]')) return;
    e.preventDefault();
    e.target.blur();
  });
  let noteTimer;
  document.addEventListener('input', (e) => {
    const n = e.target.closest('[data-cart-note]');
    if (!n) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => fetch((S.cartUpdateUrl || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) }).catch(() => {}), 500);
  });

  /* ---------------- quantity-input ---------------- */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelectorAll('button').forEach((b) => b.addEventListener('click', (e) => {
        e.preventDefault();
        const step = b.dataset.action === 'plus' ? 1 : -1;
        const min = parseInt(this.input.min || '1', 10);
        const max = this.input.max ? parseInt(this.input.max, 10) : Infinity;
        const v = Math.min(max, Math.max(min, (parseInt(this.input.value, 10) || 0) + step));
        if (v !== parseInt(this.input.value, 10)) { this.input.value = v; this.input.dispatchEvent(new Event('change', { bubbles: true })); }
      }));
    }
  }
  customElements.define('quantity-input', QuantityInput);

  /* ---------------- product-form ---------------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.form.querySelector('[type="submit"]');
      this.form.addEventListener('submit', (e) => this.submit(e));
    }
    async submit(e) {
      e.preventDefault();
      if (this.busy) return;
      if (this.button?.getAttribute('aria-disabled') === 'true') return;
      const fd = new FormData(this.form);
      // Only two things ever leave a product form: the variant and a whole quantity. No line properties,
      // so every add of the same tincture merges into its one cart line and nothing on the page can
      // attach a label of its own. Prices are Shopify's either way.
      const id = Number(fd.get('id'));
      if (!id) return;
      const quantity = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
      const items = [{ id, quantity }];
      this.busy = true;
      this.setLoading(true);
      const origin = HB.flyOrigin || this.button;
      HB.flyOrigin = null;
      // never let a stalled animation hold the drawer shut
      const flight = Promise.race([HB.flyToCart(flySource(this), origin), new Promise((r) => setTimeout(r, 1100))]);
      try {
        await HB.cart.add(items, { open: false, silent: true });
        this.form.dispatchEvent(new CustomEvent('product:added', { bubbles: true }));
        await flight;
        if (S.cartDrawer && HB.drawer) HB.drawer.open('CartDrawer'); else HB.toast(T.added || 'Added');
      } catch (err) {
        HB.toast(err.message || T.error, false);
        // a refused add (short stock) can still have changed the cart; show what is really in it
        if (typeof HB.cart.refresh === 'function') HB.cart.refresh().catch(() => {});
      }
      finally { this.busy = false; this.setLoading(false); }
    }
    setLoading(on) {
      if (!this.button) return;
      this.button.classList.toggle('is-loading', on);
      this.button.toggleAttribute('disabled', on);
    }
  }
  customElements.define('product-form', ProductForm);

  /* ---------------- quantity-ladder (1 / 2 / 3 bottles) ---------------- */
  class QuantityLadder extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.form;
      this.radios = $$('input[type="radio"]', this);
      this.radios.forEach((r) => r.addEventListener('change', () => this.apply(true)));
      this.apply(false);
    }
    // A pack is a variant with its own price: picking one switches the variant and keeps quantity 1.
    apply(fromShopper) {
      const sel = this.radios.find((r) => r.checked) || this.radios.find((r) => !r.disabled);
      if (!sel) return;
      const price = Number(sel.dataset.price) || 0;
      const compare = Number(sel.dataset.compare) || 0;
      const pack = Number(sel.dataset.pack) || 1;
      const saving = compare > price ? compare - price : 0;
      const form = this.formId ? document.getElementById(this.formId) : null;
      const idInput = form ? form.querySelector('input[name="id"]') : null;
      if (idInput) idInput.value = sel.value;
      const qInput = form ? form.querySelector('input[name="quantity"]') : null;
      if (qInput) qInput.value = 1;
      $$('[data-ladder-total]').forEach((el) => { el.textContent = money(price); });
      $$('[data-ladder-save]').forEach((el) => { el.hidden = !saving; const s = el.querySelector('[data-save-amount]'); if (s) s.textContent = money(saving); });
      $$('.ladder__option', this).forEach((o) => o.classList.toggle('is-selected', o.contains(sel)));
      $$('[data-atc-label]').forEach((el) => { if (el.dataset.template) el.textContent = el.dataset.template.replace('[price]', money(price)); });
      $$('.sticky-atc').forEach((el) => el.setAttribute('data-qty', String(pack)));
      if (fromShopper) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', sel.value);
        window.history.replaceState({}, '', url);
      }
      this.dispatchEvent(new CustomEvent('ladder:change', { bubbles: true, detail: { variant: Number(sel.value), pack, price } }));
    }
  }
  customElements.define('quantity-ladder', QuantityLadder);

  /* ---------------- variant-selects (for multi-variant products) ---------------- */
  class VariantSelects extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]'); } catch (e) { this.variants = []; }
      this.addEventListener('change', () => this.onChange());
    }
    onChange() {
      const opts = $$('select, input[type="radio"]:checked', this).map((el) => el.value);
      const v = this.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      const form = document.getElementById(this.dataset.form);
      if (!form) return;
      const idInput = form.querySelector('input[name="id"]');
      const btn = form.querySelector('[type="submit"]');
      const label = btn?.querySelector('.btn__label');
      if (!v) { btn?.setAttribute('aria-disabled', 'true'); if (label) label.textContent = T.unavailable; return; }
      idInput.value = v.id;
      btn?.setAttribute('aria-disabled', v.available ? 'false' : 'true');
      if (label) label.textContent = v.available ? (btn.dataset.template ? btn.dataset.template.replace('[price]', money(v.price)) : T.addToCart) : T.soldOut;
      $$('[data-variant-price]').forEach((el) => { el.textContent = money(v.price); });
      if (v.featured_media?.preview_image?.src || v.featured_image?.src) {
        const gallery = $('product-gallery'); if (gallery) gallery.goToMedia(v.featured_media?.id || v.featured_image?.id);
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /* ---------------- product-gallery ---------------- */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = $$('[data-slide]', this);
      this.thumbs = $$('[data-thumb]', this);
      this.index = 0;
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      $$('[data-gallery-prev]', this).forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));
      $$('[data-gallery-next]', this).forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
      this.viewport = $('[data-viewport]', this);
      if (this.viewport) {
        let sx = 0;
        this.viewport.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
        this.viewport.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) this.go(dx < 0 ? this.index - 1 : this.index + 1); });
      }
      this.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') this.go(this.index + 1); if (e.key === 'ArrowRight') this.go(this.index - 1); });
      this.go(0);
    }
    go(i) {
      if (!this.slides.length) return;
      i = (i + this.slides.length) % this.slides.length;
      this.index = i;
      this.slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); });
      this.thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); if (k === i) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduced ? 'auto' : 'smooth' }); });
      const counter = $('[data-gallery-counter]', this); if (counter) counter.textContent = `${i + 1} / ${this.slides.length}`;
    }
    goToMedia(id) { const k = this.slides.findIndex((s) => String(s.dataset.mediaId) === String(id)); if (k >= 0) this.go(k); }
  }
  customElements.define('product-gallery', ProductGallery);

  /* ---------------- hb-carousel ---------------- */
  class Carousel extends HTMLElement {
    connectedCallback() {
      this.track = $('.carousel__track', this);
      if (!this.track) return;
      // arrows may live inside the slides (one pair per slide) or outside the element in a [data-nav-for="<section id>"] container
      const secId = (this.closest('.shopify-section')?.id || '').replace('shopify-section-', '');
      const external = secId ? $$('[data-nav-for="' + secId + '"]') : [];
      const scopes = [this].concat(external);
      this.prevs = scopes.flatMap((sc) => $$('[data-prev]', sc));
      this.nexts = scopes.flatMap((sc) => $$('[data-next]', sc));
      this.dotsWrap = $('.carousel__dots', this) || external.map((sc) => $('.carousel__dots', sc)).find(Boolean) || null;
      this.items = [];
      // RTL: "next" means moving to more content = scrollLeft decreases
      this.prevs.forEach((b) => b.addEventListener('click', () => this.scrollBy(-1)));
      this.nexts.forEach((b) => b.addEventListener('click', () => this.scrollBy(1)));
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); }, { passive: true });
      window.addEventListener('resize', () => this.refresh());
      // cards get hidden/shown by filters or replaced by fetches: recompute items, dots and arrow state
      this.mo = new MutationObserver(() => { clearTimeout(this.moTimer); this.moTimer = setTimeout(() => this.refresh(), 40); });
      this.mo.observe(this.track, { childList: true, attributes: true, attributeFilter: ['hidden', 'style'] });
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(() => this.update()); this.ro.observe(this.track); }
      this.initDrag();
      this.refresh();
      if (this.dataset.autoplay && !reduced) { this.timer = setInterval(() => { if (!this.hasOverflow() || noMotion()) return; if (this.atEnd()) this.track.scrollTo({ left: 0, behavior: 'smooth' }); else this.scrollBy(1); }, Number(this.dataset.autoplay) || 5000); this.addEventListener('pointerenter', () => clearInterval(this.timer)); }
    }
    // grab and drag with a mouse, the way touch already works. Touch is left to the browser.
    initDrag() {
      const t = this.track;
      let id = null, x0 = 0, left0 = 0, lastX = 0, dragging = false;
      const down = (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || !this.hasOverflow()) return;
        if (e.target.closest('button, a[download], input, select, textarea, video, .carousel__dot')) return;
        id = e.pointerId; x0 = lastX = e.clientX; left0 = t.scrollLeft; dragging = false;
      };
      const move = (e) => {
        if (id === null || e.pointerId !== id) return;
        lastX = e.clientX;
        const dx = lastX - x0;
        if (!dragging) {
          if (Math.abs(dx) < 6) return;                  // under the threshold this is still a click
          dragging = true;
          t.classList.add('is-dragging');
          // capture only once it really is a drag: capturing on pointerdown would retarget the
          // following click to the track and stop a plain click on a card from opening it
          try { t.setPointerCapture(id); } catch (err) { /* capture is best effort */ }
        }
        t.scrollLeft = left0 - dx;
        e.preventDefault();
      };
      const up = () => {
        if (id === null) return;
        try { t.releasePointerCapture(id); } catch (err) { /* already released */ }
        id = null;
        if (!dragging) return;                           // plain click, leave it alone
        dragging = false;
        this.dragged = true;
        setTimeout(() => { this.dragged = false; }, 0);
        // land on a whole slide. A long drag lands on the nearest one; a short deliberate flick
        // still advances one, which is what full-width slides need (snap alone would spring back)
        const step = this.step() || 1;
        const dx = lastX - x0;
        const from = Math.round(left0 / step);
        let idx = Math.round(t.scrollLeft / step);
        if (idx === from && Math.abs(dx) > Math.max(40, step * 0.15)) idx = from - Math.sign(dx);
        const span = t.scrollWidth - t.clientWidth;
        let target = idx * step;
        target = getComputedStyle(t).direction === 'rtl' ? Math.min(0, Math.max(-span, target)) : Math.max(0, Math.min(span, target));
        t.scrollTo({ left: target, behavior: 'smooth' });
        clearTimeout(this.settle);
        this.settle = setTimeout(() => t.classList.remove('is-dragging'), 420);
      };
      t.addEventListener('pointerdown', down);
      t.addEventListener('pointermove', move);
      t.addEventListener('pointerup', up);
      t.addEventListener('pointercancel', up);
      t.addEventListener('lostpointercapture', up);
      // a card is a link, so a drag that ends on one must not navigate
      t.addEventListener('click', (e) => { if (this.dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
      t.addEventListener('dragstart', (e) => e.preventDefault());
    }
    disconnectedCallback() { this.mo?.disconnect(); this.ro?.disconnect(); clearInterval(this.timer); clearTimeout(this.settle); }
    visibleItems() { return Array.from(this.track.children).filter((el) => !el.hidden && getComputedStyle(el).display !== 'none'); }
    refresh() {
      this.items = this.visibleItems();
      if (this.dotsWrap) this.dotsWrap.innerHTML = '';
      this.update();
    }
    // One dot per position the track can actually stop at. With two cards in view, six cards give
    // five stops, not six - otherwise the last dot can never light up and the end looks unreached.
    stops() {
      const step = this.step() || 1;
      const span = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      // a final step shorter than a card is still a stop of its own (ceil), minus a hair of float slack
      return Math.max(1, Math.min(this.items.length || 1, Math.ceil(span / step - 0.05) + 1));
    }
    syncDots() {
      if (!this.dotsWrap) return 0;
      const n = this.stops();
      if (this.dotsWrap.children.length === n) return n;
      this.dotsWrap.innerHTML = '';
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'carousel__dot'; b.setAttribute('aria-label', String(i + 1));
        b.addEventListener('click', () => {
          const span = this.track.scrollWidth - this.track.clientWidth;
          const target = i === n - 1 ? span : Math.min(span, i * this.step());
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.track.scrollTo({ left: rtl ? -target : target, behavior: 'smooth' });
        });
        this.dotsWrap.appendChild(b);
      }
      return n;
    }
    toStart() { this.track.scrollTo({ left: 0, behavior: 'instant' }); this.update(); }
    step() { const first = this.items[0]; return first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 16) : 300; }
    scrollBy(dir) { const rtl = getComputedStyle(this.track).direction === 'rtl'; this.track.scrollBy({ left: (rtl ? -1 : 1) * dir * this.step(), behavior: 'smooth' }); }
    hasOverflow() { return this.track.scrollWidth > this.track.clientWidth + 4; }
    atEnd() { return Math.abs(this.track.scrollLeft) + this.track.clientWidth >= this.track.scrollWidth - 4; }
    update() {
      const overflow = this.hasOverflow();
      this.classList.toggle('is-static', !overflow);
      const pos = Math.abs(this.track.scrollLeft);
      const prevOff = !overflow || pos < 4; const nextOff = !overflow || this.atEnd();
      this.prevs.forEach((b) => { b.disabled = prevOff; });
      this.nexts.forEach((b) => { b.disabled = nextOff; });
      if (this.dotsWrap) {
        const n = this.syncDots();
        // at the end the last stop is the one showing, even if the final step was shorter than a card
        const idx = overflow && this.atEnd() ? n - 1 : Math.min(n - 1, Math.round(pos / this.step()));
        $$('.carousel__dot', this.dotsWrap).forEach((d, i) => { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      }
    }
  }
  customElements.define('hb-carousel', Carousel);

  /* ---------------- count-up ---------------- */
  class CountUp extends HTMLElement {
    connectedCallback() {
      this.target = parseFloat(this.dataset.value || this.textContent) || 0;
      this.decimals = (String(this.dataset.value || '').split('.')[1] || '').length;
      this.pre = this.dataset.prefix || ''; this.suf = this.dataset.suffix || '';
      this.render(this.target);
      if (reduced || !('IntersectionObserver' in window)) { this.done = true; return; }
      const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { this.run(); io.disconnect(); } }, { threshold: .3 });
      io.observe(this);
    }
    run() {
      if (this.done) { return; }
      const start = performance.now(); const dur = 1400;
      const tick = (now) => { const p = Math.min(1, (now - start) / dur); const eased = 1 - Math.pow(1 - p, 3); this.render(this.target * eased); if (p < 1) requestAnimationFrame(tick); else this.done = true; };
      requestAnimationFrame(tick);
    }
    render(v) { this.textContent = this.pre + v.toLocaleString('en-US', { minimumFractionDigits: this.decimals, maximumFractionDigits: this.decimals }) + this.suf; }
  }
  customElements.define('count-up', CountUp);

  /* ---------------- goal-filter (chips filter cards by data-goals) ---------------- */
  class GoalFilter extends HTMLElement {
    connectedCallback() {
      this.chips = $$('[data-goal]', this);
      this.gridSel = this.dataset.target;
      this.chips.forEach((c) => c.addEventListener('click', () => this.select(c.dataset.goal)));
    }
    select(goal) {
      this.chips.forEach((c) => { const on = c.dataset.goal === goal; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', String(on)); });
      const grid = this.gridSel ? $(this.gridSel) : null;
      if (!grid) return;
      let visible = 0;
      $$('[data-goals]', grid).forEach((item) => { const show = goal === 'all' || (item.dataset.goals || '').split(/[,\s]+/).includes(goal); item.hidden = !show; if (show) { visible++; item.classList.add('is-visible'); } });
      const empty = $('[data-goal-empty]', grid.parentElement); if (empty) empty.hidden = visible > 0;
      const car = grid.closest('hb-carousel'); if (car && car.refresh) { car.refresh(); car.toStart(); }
    }
  }
  customElements.define('goal-filter', GoalFilter);

  /* ---------------- scroll-hint (edge fade + arrow on sideways-scrolling rows) ---------------- */
  class ScrollHint extends HTMLElement {
    connectedCallback() {
      this.sc = this.firstElementChild;
      if (!this.sc) return;
      this.update = this.update.bind(this);
      this.sc.addEventListener('scroll', this.update, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(this.update).observe(this.sc);
      const arrow = $('.scroll-hint__arrow', this);
      if (arrow) arrow.addEventListener('click', () => {
        const dir = getComputedStyle(this.sc).direction === 'rtl' ? -1 : 1;
        this.sc.scrollBy({ left: dir * this.sc.clientWidth * 0.6, behavior: 'smooth' });
      });
      this.update();
    }
    update() {
      const max = this.sc.scrollWidth - this.sc.clientWidth;
      const pos = Math.abs(this.sc.scrollLeft);
      this.classList.toggle('has-more-start', max > 2 && pos > 2);
      this.classList.toggle('has-more-end', max > 2 && pos < max - 2);
    }
  }
  customElements.define('scroll-hint', ScrollHint);

  /* ---------------- sticky-atc (mobile) ---------------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const anchor = document.getElementById(this.dataset.watch || 'BuyBox');
      if (!anchor) return;
      // shown once the buy box has scrolled away above the screen, hidden again while the footer is on screen
      let pastBuy = false, atFooter = false;
      const sync = () => this.classList.toggle('is-visible', pastBuy && !atFooter);
      const io = new IntersectionObserver((entries) => { const e = entries[0]; pastBuy = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); });
      io.observe(anchor);
      const footer = document.querySelector('.footer');
      if (footer) new IntersectionObserver((entries) => { atFooter = entries[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -60px 0px' }).observe(footer);
      this.querySelector('button')?.addEventListener('click', (e) => {
        const form = document.getElementById(this.dataset.form);
        if (!form) return;
        HB.flyOrigin = e.currentTarget; // the flight should start from the sticky bar, not the buy box
        form.requestSubmit();
      });
    }
  }
  customElements.define('sticky-atc', StickyAtc);

  /* ---------------- share-button ---------------- */
  class ShareButton extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('button');
      btn?.addEventListener('click', async () => {
        const data = { title: document.title, url: this.dataset.url || window.location.href };
        if (navigator.share) { try { await navigator.share(data); } catch (e) { /* cancelled */ } }
        else { try { await navigator.clipboard.writeText(data.url); HB.toast(T.copied); } catch (e) { /* ignore */ } }
      });
    }
  }
  customElements.define('share-button', ShareButton);

  /* ---------------- tabs ---------------- */
  class HbTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = $$('[role="tab"]', this); this.panels = $$('[role="tabpanel"]', this);
      this.tabs.forEach((t, i) => t.addEventListener('click', () => this.show(i)));
      this.show(0);
    }
    show(i) { this.tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.classList.toggle('is-active', k === i); }); this.panels.forEach((p, k) => { p.hidden = k !== i; }); }
  }
  customElements.define('hb-tabs', HbTabs);

  /* ---------------- header: sticky + scrolled ---------------- */
  function initHeader() {
    const wrap = $('.header-wrapper');
    if (!wrap) return;
    // stick the Shopify section wrapper itself, not the header inside it
    const sticky = wrap.closest('.shopify-section') || wrap;
    sticky.classList.add('section-header');
    if (S.stickyHeader !== false) sticky.classList.add('is-sticky');
    const onScroll = () => sticky.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    const setH = () => document.documentElement.style.setProperty('--header-h', wrap.offsetHeight + 'px');
    setH(); window.addEventListener('resize', setH);
  }

  /* ---------------- reveal ---------------- */
  function initReveal() {
    if (S.animations === false || reduced) { document.documentElement.classList.add('no-anim'); return; }
    const all = $$('[data-reveal]:not(.is-visible)');
    const els = all.filter((e) => { if (e.closest('.carousel__track')) { e.classList.add('is-visible'); return false; } return true; });
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting || e.boundingClientRect.top < 0) { e.target.classList.add('is-visible'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -4% 0px', threshold: 0 });
    els.forEach((e) => io.observe(e));
    setTimeout(() => els.forEach((e) => e.classList.add('is-visible')), 1500);
  }

  /* ---------------- boot ---------------- */
  /* ---------------- effects diagram: a right-side label hugs its leader ----------------
     Right-aligned text that wraps keeps the full box width, leaving a gap between the leader and the
     shorter first line; the box is shrunk to its longest line instead (desktop layout only). */
  function fitFxNodes() {
    $$('.fx__node--r').forEach((n) => {
      n.style.width = '';
      if (getComputedStyle(n).textAlign !== 'right') return;
      let max = 0;
      $$('.fx__node-title, .fx__node-text', n).forEach((el) => {
        const r = document.createRange(); r.selectNodeContents(el);
        [...r.getClientRects()].forEach((rect) => { max = Math.max(max, rect.width); });
      });
      if (max) n.style.width = Math.ceil(max + 2) + 'px';
    });
  }
  let fxT;
  window.addEventListener('resize', () => { clearTimeout(fxT); fxT = setTimeout(fitFxNodes, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitFxNodes);

  function boot() { initHeader(); initReveal(); fitFxNodes(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => { initReveal(); fitFxNodes(); });
})();

class HeroBottles extends HTMLElement {
  connectedCallback() {
    const items = [...this.querySelectorAll('.hbot__item, .hbot__shroom, .hbot__leaf')];
    const settle = (li) => li.classList.add('is-in');
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    items.forEach((li) => {
      if (reduce) { settle(li); return; }
      li.addEventListener('animationend', (e) => { if (e.target === li && (e.animationName === 'hbot-enter' || e.animationName === 'hbot-fly' || e.animationName === 'hbot-leaf')) settle(li); });
      const anims = li.getAnimations ? li.getAnimations() : [];
      if (anims.length && anims.every((a) => a.playState === 'finished')) settle(li);
    });
    const arm = () => setTimeout(() => items.forEach(settle), 3600);
    if (this.classList.contains('hbot--wait')) this.addEventListener('hbot:go', arm, { once: true }); else arm();
  }
}
if (!customElements.get('hero-bottles')) customElements.define('hero-bottles', HeroBottles);

class ProductSwitcher extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.psw__slide')];
    this.cards = [...this.querySelectorAll('.psw__card')];
    this.chips = [...this.querySelectorAll('[data-psw-go]')];
    this.index = 0;
    this.busy = false;
    const prev = this.querySelector('[data-psw-prev]');
    const next = this.querySelector('[data-psw-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
    if (next) next.addEventListener('click', () => this.go(this.index + 1));
    this.chips.forEach((c) => c.addEventListener('click', () => this.go(Number(c.dataset.pswGo))));
    this.hand = this.querySelector('.psw__hand img');
    this.stage = this.querySelector('.psw__stage');
    const place = () => this.placeLanding();
    if (this.hand && !this.hand.complete) this.hand.addEventListener('load', place, { once: true });
    place();
    requestAnimationFrame(place);
    window.addEventListener('resize', () => { clearTimeout(this.rt); this.rt = setTimeout(place, 120); });
    this.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') this.go(this.index + 1); if (e.key === 'ArrowRight') this.go(this.index - 1); });
    const delay = Number(this.dataset.autoplay || 0) * 1000;
    if (delay > 0 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      this.delay = delay;
      this.paused = false;
      this.visible = false;
      ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => { this.paused = true; this.stop(); }, { passive: true }));
      ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => { this.paused = false; this.start(); }));
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; if (this.visible) this.start(); else this.stop(); }, { threshold: .35 }).observe(this);
      } else { this.visible = true; this.start(); }
    }
  }
  slideSheets(from, to) {
    const sheets = [...this.querySelectorAll('.psw__sheet')];
    if (sheets.length < 2) return;
    const n = sheets.length;
    let dir = to > from ? 1 : -1;
    if (Math.abs(to - from) > n / 2) dir = -dir;
    const outgoing = sheets[from];
    const incoming = sheets[to];
    sheets.forEach((sh) => { if (sh !== outgoing && sh !== incoming) sh.classList.remove('is-active', 'is-out-left', 'is-out-right'); });
    incoming.classList.add('no-trans');
    incoming.classList.remove('is-active', 'is-out-left', 'is-out-right');
    incoming.classList.add(dir > 0 ? 'is-out-left' : 'is-out-right');
    void incoming.offsetWidth;
    incoming.classList.remove('no-trans');
    incoming.classList.remove('is-out-left', 'is-out-right');
    incoming.classList.add('is-active');
    outgoing.classList.remove('is-active');
    outgoing.classList.add(dir > 0 ? 'is-out-right' : 'is-out-left');
    const bg = this.slides[to] && this.slides[to].dataset.bg;
    if (bg) setTimeout(() => this.style.setProperty('--bg', bg), 900);
  }
  placeLanding() {
    if (!this.stage) return;
    const st = this.stage.getBoundingClientRect();
    if (!st.height) return;
    if (this.hand) {
      const land = Number(this.dataset.land || 58) / 100;
      const h = this.hand.getBoundingClientRect();
      if (h.height) this.style.setProperty('--land', Math.round(st.bottom - (h.top + h.height * land)) + 'px');
    }
    const bottle = this.querySelector('.psw__bottle');
    if (!bottle) return;
    const b = bottle.getBoundingClientRect();
    const cx = b.left + b.width / 2;
    const cy = b.top + b.height * .68;
    this.querySelectorAll('.psw__shroom').forEach((m) => {
      const r = m.getBoundingClientRect();
      m.style.setProperty('--dx', Math.round(cx - (r.left + r.width / 2)) + 'px');
      m.style.setProperty('--dy', Math.round(cy - (r.top + r.height / 2)) + 'px');
    });
  }
  start() { if (!this.delay || this.paused || !this.visible) return; this.stop(); this.timer = setInterval(() => this.go(this.index + 1), this.delay); }
  stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  go(i) {
    const n = this.slides.length;
    if (!n) return;
    const to = ((i % n) + n) % n;
    if (to === this.index || this.busy) return;
    this.busy = true;
    const from = this.index;
    this.index = to;
    const leaving = this.slides[from];
    const entering = this.slides[to];
    leaving.classList.remove('is-active');
    leaving.classList.add('is-leaving');
    setTimeout(() => leaving.classList.remove('is-leaving'), 500);
    entering.classList.add('is-active');
    if (entering.dataset.accent) this.style.setProperty('--accent', entering.dataset.accent);
    this.slideSheets(from, to);
    this.cards.forEach((c, k) => { c.hidden = k !== to; c.classList.toggle('is-active', k === to); });
    this.chips.forEach((c, k) => { c.classList.toggle('is-active', k === to); c.setAttribute('aria-selected', k === to ? 'true' : 'false'); });
    const chip = this.chips[to];
    const rail = chip && chip.parentElement;
    if (chip && rail && rail.scrollWidth > rail.clientWidth + 4) { const c = rail.getBoundingClientRect(); const r = chip.getBoundingClientRect(); rail.scrollBy({ left: (r.left + r.width / 2) - (c.left + c.width / 2), behavior: 'smooth' }); }
    setTimeout(() => { this.busy = false; }, 420);
    if (this.delay && this.timer) this.start();
  }
}
if (!customElements.get('product-switcher')) customElements.define('product-switcher', ProductSwitcher);
